import { useOverlayContext } from 'seagull';
import { useIoContext, useStore, useStoreActions } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { selectors } from '~/store/state-selectors';
import { tasksStore } from '~/tasks-drawer/tasksStore';
import { useFeatureFlags } from '../useFeatureFlags';
export function useDownloadAgreementPdf() {
    const pdfHost = useStore(selectors.pdfHost);
    const { browser: { openNewTab } } = useIoContext();
    const { api } = useStoreActions();
    const { RELATIONSHIP_PDF_SCOUT } = useFeatureFlags();
    const { showErrorToast } = useOverlayContext();
    const { t: texts } = useLocaleKeys('tasksDrawer');
    return {
        downloadAgreementPdf (relationshipId, lang) {
            if (!RELATIONSHIP_PDF_SCOUT) {
                openNewTab("".concat(pdfHost, "/relationship-pdf/").concat(relationshipId));
                return;
            }
            api.pdf.generateRelationshipPdf(relationshipId, lang).then((res)=>{
                tasksStore.addTask({
                    kind: 'relationshipPdf',
                    jobId: res.jobId,
                    agreementName: res.agreementName,
                    createdAt: Date.now(),
                    status: res.status,
                    progress: res.progress
                });
            }).catch(()=>{
                showErrorToast(texts.relationshipPdf.startFailedToast(), 'download-agreement-pdf-error');
            });
        }
    };
}
